const trusteeTypes = {
  AU: [
    {
      value: 1,
      label: 'screens.businessInformation.trusteeTypeOptions.individual',
    },
    {
      value: 2,
      label: 'screens.businessInformation.trusteeTypeOptions.company',
    },
  ],
  NZ: [
    {
      value: 1,
      label: 'screens.businessInformation.trusteeTypeOptions.individual',
    },
    {
      value: 2,
      label: 'screens.businessInformation.trusteeTypeOptions.company',
    },
  ],
};

export default trusteeTypes;
